var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        [
          _c("h3", { staticClass: "title typographies-heading-h3" }, [
            _vm._v("\n        " + _vm._s(_vm.sectionTitle) + "\n    ")
          ]),
          _vm._v(" "),
          _vm.showLimits
            ? _c("h4", { staticClass: "subtitle typographies-heading-h4" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$l10n.__("Crédits")) + "\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "subscription-manager__buy-quota" },
            [
              _c(
                "p",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Votre abonnement inclus des crédits liés au plan choisi. Si vous ne pouvez plus effectuer certaines actions car vos crédits sont épuisés, il est possible d’en acheter des nouveaux en fonction de vos besoins."
                        )
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.licenseAssignement && _vm.shouldDisplayBuyQuotaBtn
                ? _c("CompassButton", {
                    staticClass: "buy-quota-btn",
                    attrs: { label: _vm.$t.__("common.actions.buy_credits") },
                    on: { click: _vm.onClickBuyQuota }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("LimitsAndCreditsTable", { attrs: { items: _vm.listQuota } }),
          _vm._v(" "),
          _vm.showLimits
            ? _c(
                "div",
                { staticClass: "limits-section" },
                [
                  _c(
                    "h4",
                    { staticClass: "subtitle typographies-heading-h4" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$l10n.__("Limites")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "subscription-manager__buy-quota" },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "typographies-paragraph-medium-regular"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$l10n.__(
                                  "Votre abonnement inclus des limites liées au plan choisi. Si vous ne pouvez plus effectuer certaines actions car une ou plusieurs limites sont atteintes, il est possible de passer au plan supérieur."
                                )
                              ) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("CompassButton", {
                        staticClass: "buy-quota-btn",
                        attrs: {
                          label: _vm.$t.__("common.actions.contact_sales")
                        },
                        on: { click: _vm.openIntercom }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("LimitsAndCreditsTable", {
                    attrs: { items: _vm.limitsList, type: "limit" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.shouldDisplayDialogChargebeeQuota
            ? _c("ChargebeeQuotaDialog", {
                attrs: { credits: _vm.listQuota },
                on: {
                  onClose: function($event) {
                    _vm.shouldDisplayDialogChargebeeQuota = false
                  },
                  onValidate: _vm.onValidateQuotaBuying
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }